const statusOptions = [
    { text: 'TODAS', value: -1 },
    { text: 'EM ANÁLISE', value: 0 },
    { text: 'APROVADAS', value: 1 },
    { text: 'REPROVADAS', value: 2 }
]

export default statusOptions
